import { render, staticRenderFns } from "./VectraitsFileUploadDetail.vue?vue&type=template&id=6a81b38c&scoped=true&"
import script from "./VectraitsFileUploadDetail.vue?vue&type=script&lang=js&"
export * from "./VectraitsFileUploadDetail.vue?vue&type=script&lang=js&"
import style0 from "./VectraitsFileUploadDetail.vue?vue&type=style&index=0&id=6a81b38c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a81b38c",
  null
  
)

export default component.exports